class Menu {
    static init() {
        this.header = document.querySelector(".header");
        this.lastScroll = window.scrollY || 0;

        if (this.header) {
            const TOP_THRESHOLD = 10;

            const onScroll = () => {
                const currentScroll = window.scrollY || 0;

                // Always show header near the top (iOS Safari bounce scroll fix)
                if (currentScroll <= TOP_THRESHOLD) {
                    this.header.classList.remove("header--hidden");
                    this.header.classList.remove("header--scrolled-up");

                    this.lastScroll = currentScroll;
                    return;
                }

                if (currentScroll > this.lastScroll) {
                    // Scrolling down
                    this.header.classList.add("header--hidden");
                    this.header.classList.remove("header--scrolled-up");
                } else {
                    // Scrolling up
                    this.header.classList.remove("header--hidden");
                    this.header.classList.add("header--scrolled-up");
                }

                this.lastScroll = currentScroll;
            };

            document.addEventListener("scroll", onScroll);

            onScroll();
        }
    }
}

export default Menu;
